var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63996 2.87988H1.91996C1.38977 2.87988 0.959961 3.30969 0.959961 3.83988V20.1599C0.959961 20.6901 1.38977 21.1199 1.91996 21.1199H22.08C22.6102 21.1199 23.04 20.6901 23.04 20.1599V7.67988C23.04 7.14969 22.6102 6.71988 22.08 6.71988H21.12V3.83988L9.59996 3.83988C9.59996 3.30969 9.17015 2.87988 8.63996 2.87988ZM8.63996 4.79988L8.63996 3.83988H1.91996V20.1599H22.08V7.67988H8.63996L8.63996 4.79988ZM9.59996 4.79988H20.16V6.71988H9.59996V4.79988ZM17.28 11.5199H5.75996V12.4799H17.28V11.5199ZM5.75996 15.3599H15.36V16.3199H5.75996V15.3599Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;